import { api, errorMessage } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { useUi } from '@/lib/store';
import { prepareCall } from './prepare';

/** Start (or join the ongoing) call for a conversation or project. */
export function useStartCall() {
  const ws = useWorkspaceId();
  const setActiveCall = useUi(s => s.setActiveCall);
  const toast = useUi(s => s.toast);
  return async (b: { conversation_id?: string; project_id?: string; media: 'audio' | 'video'; invitee_ids?: string[] }) => {
    if (!ws) return;
    if (useUi.getState().activeCall) { toast('You are already in a call', 'error'); return; }
    prepareCall(); // t437u: warm LiveKit while POST /calls runs
    try {
      setActiveCall(await api.startCall({ workspace_id: ws, ...b }));
    } catch (e) {
      toast(`Couldn't start the call: ${errorMessage(e)}`, 'error');
    }
  };
}
